import { useCallback } from "react";
import { INotification } from "../../store/types";
import { NotificationHandlerType } from "./use-click-handler";
import { useNavigate } from "hooks/shared-hooks/use-navigate";

export function useTaggerHook(): NotificationHandlerType {
  const navigate = useNavigate();

  return useCallback(async ({ components }: INotification) => {
    if ((components.deal_id || components.deal_ids) && components.file_ids) {
      navigate({
        route: "tagger",
        search: {
          ...(components.deal_id ? { dealId: components.deal_id } : null),
          ...(components.deal_ids ? { dealIds: components.deal_ids } : null),
          filesIds: components.file_ids,
          ...(components.section_id ? { section: components.section_id } : null)
          // taggerFile: 1
        },
        setQueriesMethod: "replace",
        params: {}
      });
    }
  }, []);
}
